<template>
  <section class="section">
    <form>
      <div class="container">
        <div class="columns">
          <div class="column is-10">
            <h1 class="title">{{ $translate('copy_order') | capitalize }}</h1>
          </div>
          <div class="column is-2 has-text-right">
            <button
              type="button"
              class="button is-primary"
              :disabled="isSaveDisabled"
              slot="trigger"
              @click="validateBeforeSubmit()"
            >
              <b-icon icon="content-save-outline"></b-icon>
            </button>
          </div>
        </div>

        <b-field :label="$translate('primaryCode')" horizontal>
          <b-field :type="{ 'is-danger': errors.has('primaryCode') }" :message="errors.first('primaryCode')">
            <b-input v-model="ordertoarrive.primaryCode" name="primaryCode" v-validate="'required|unique'"></b-input>
          </b-field>
          <b-button type="button" class="button is-primary" @click="primaryCodeCreation()" icon-right="auto-fix">
            {{ $translate('generate_primaryCode') | capitalize }}
          </b-button>
        </b-field>

        <b-field
          :label="$translate('secondaryCode')"
          :type="{ 'is-danger': errors.has('secondaryCode') }"
          :message="errors.first('secondaryCode')"
          horizontal
        >
          <b-input v-model="ordertoarrive.secondaryCode" name="secondaryCode"></b-input>
        </b-field>
        <b-field
          :label="$translate('shoeType') | capitalize"
          :type="{ 'is-danger': errors.has('shoeType') }"
          :message="errors.first('shoeType')"
          horizontal
        >
          <b-select
            name="shoeType"
            v-model="ordertoarrive.shoeType"
            v-validate="'required'"
            :placeholder="$translate('placeholder_select')"
            :disabled="this.copyModel"
          >
            <option v-for="type in $availableShoeType" :key="type" :value="type">
              {{ $translate(type) | capitalize }}
            </option>
          </b-select>
        </b-field>
        <b-field :label="$translate('share_attach') | capitalize" horizontal>
          <b-switch v-model="copyAttachbool"> </b-switch>
        </b-field>
        <template v-if="orderTypeDictionary && orderTypeDictionary.length != 0">
          <b-field
            :label="$translate('orderType') | capitalize"
            :type="{ 'is-danger': errors.has('orderType') }"
            :message="errors.first('orderType')"
            horizontal
          >
            <b-select
              name="orderType"
              v-model="ordertoarrive.orderType"
              :placeholder="$translate('placeholder_type')"
              v-validate="'required'"
              @input="
                ordertoarrive.orderTypeMain = null
                ordertoarrive.orderTypeVariant = null
                ordertoarrive.orderTypeSubVariant = null
                $forceUpdate()
              "
            >
              <option v-for="optio in orderTypeDictionary" :key="optio.key" :value="optio.key">
                {{ $translate(optio.key) | capitalize }}
              </option>
            </b-select>
          </b-field>
        </template>
        <template
          v-if="
            orderTypeDictionary &&
              orderTypeDictionary.length != 0 &&
              orderTypeDictionary.find(temp => temp.key === ordertoarrive.orderType) != undefined &&
              orderTypeDictionary.find(temp => temp.key === ordertoarrive.orderType).variant
          "
        >
          <b-field
            :label="$translate('orderTypeMain') | capitalize"
            :type="{ 'is-danger': errors.has('orderTypeMain') }"
            :message="errors.first('orderTypeMain')"
            v-if="orderTypeDictionary.find(temp => temp.key === ordertoarrive.orderType).variant"
            horizontal
          >
            <b-select
              name="orderTypeMain"
              v-model="ordertoarrive.orderTypeMain"
              :placeholder="$translate('placeholder_type')"
              v-validate="'required'"
              @input="
                ordertoarrive.orderTypeVariant = null
                ordertoarrive.orderTypeSubVariant = null
                $forceUpdate()
              "
            >
              <option
                v-for="variant in orderTypeDictionary.find(temp => temp.key === ordertoarrive.orderType).variant"
                :key="variant.key"
                :value="variant.key"
              >
                {{ $translate(variant.key) }}
              </option>
            </b-select>
          </b-field>
        </template>

        <template
          v-if="
            orderTypeDictionary &&
              orderTypeDictionary.length != 0 &&
              orderTypeDictionary.find(temp => temp.key === ordertoarrive.orderType) != undefined &&
              orderTypeDictionary.find(temp => temp.key === ordertoarrive.orderType).variant &&
              orderTypeDictionary
                .find(temp => temp.key === ordertoarrive.orderType)
                .variant.find(temp => temp.key === ordertoarrive.orderTypeMain) != undefined
          "
        >
          <b-field
            :label="$translate('orderTypeVariant') | capitalize"
            :type="{ 'is-danger': errors.has('orderTypeVariant') }"
            :message="errors.first('orderTypeVariant')"
            v-if="
              orderTypeDictionary
                .find(temp => temp.key === ordertoarrive.orderType)
                .variant.find(temp => temp.key === ordertoarrive.orderTypeMain).variant
            "
            horizontal
          >
            <b-select
              name="orderTypeVariant"
              v-model="ordertoarrive.orderTypeVariant"
              :placeholder="$translate('placeholder_type')"
              v-validate="'required'"
              @input="
                ordertoarrive.orderTypeSubVariant = null
                $forceUpdate()
              "
            >
              <option
                v-for="subvariant in orderTypeDictionary
                  .find(temp => temp.key === ordertoarrive.orderType)
                  .variant.find(temp => temp.key === ordertoarrive.orderTypeMain).variant"
                :key="subvariant.key"
                :value="subvariant.key"
              >
                {{ $translate(subvariant.key) }}
              </option>
            </b-select>
          </b-field>
        </template>

        <template
          v-if="
            orderTypeDictionary &&
              orderTypeDictionary.length != 0 &&
              orderTypeDictionary.find(temp => temp.key === ordertoarrive.orderType) != undefined &&
              orderTypeDictionary.find(temp => temp.key === ordertoarrive.orderType).variant &&
              orderTypeDictionary
                .find(temp => temp.key === ordertoarrive.orderType)
                .variant.find(temp => temp.key === ordertoarrive.orderTypeMain) != undefined &&
              orderTypeDictionary
                .find(temp => temp.key === ordertoarrive.orderType)
                .variant.find(temp => temp.key === ordertoarrive.orderTypeMain).variant &&
              orderTypeDictionary
                .find(temp => temp.key === ordertoarrive.orderType)
                .variant.find(temp => temp.key === ordertoarrive.orderTypeMain)
                .variant.find(temp => temp.key === ordertoarrive.orderTypeVariant) != undefined
          "
        >
          <b-field
            :label="$translate('orderTypeSubVariant') | capitalize"
            :type="{ 'is-danger': errors.has('orderTypeSubVariant') }"
            :message="errors.first('orderTypeSubVariant')"
            horizontal
            v-if="
              orderTypeDictionary
                .find(temp => temp.key === ordertoarrive.orderType)
                .variant.find(temp => temp.key === ordertoarrive.orderTypeMain)
                .variant.find(temp => temp.key === ordertoarrive.orderTypeVariant).variant
            "
          >
            <b-select
              name="orderTypeSubVariant"
              v-model="ordertoarrive.orderTypeSubVariant"
              :placeholder="$translate('placeholder_type')"
              v-validate="'required'"
            >
              <option
                v-for="subsubvariant in orderTypeDictionary
                  .find(temp => temp.key === ordertoarrive.orderType)
                  .variant.find(temp => temp.key === ordertoarrive.orderTypeMain)
                  .variant.find(temp => temp.key === ordertoarrive.orderTypeVariant).variant"
                :key="subsubvariant.key"
                :value="subsubvariant.key"
              >
                {{ $translate(subsubvariant.key) }}
              </option>
            </b-select>
          </b-field>
        </template>

        <b-field
          :label="$translate('formcode') | capitalize"
          :type="{ 'is-danger': errors.has('formcode') }"
          :message="errors.first('formcode')"
          v-if="
            ordertoarrive.orderTypeVariant == 'card2' ||
              (ordertoarrive.orderTypeVariant && ordertoarrive.orderTypeMain == 'last') ||
              (ordertoarrive.orderTypeVariant && ordertoarrive.orderTypeMain == 'mold')
          "
          horizontal
        >
          <b-input name="formcode" v-model="ordertoarrive.formcode"></b-input>
        </b-field>

        <template v-if="deliveryTypeDictionary && deliveryTypeDictionary.length != 0">
          <b-field
            :label="$translate('deliverySelected') | capitalize"
            :type="{ 'is-danger': errors.has('deliverySelected') }"
            :message="errors.first('deliverySelected')"
            horizontal
          >
            <b-select
              name="deliverySelected"
              v-model="ordertoarrive.deliverySelected"
              :placeholder="$translate('placeholder_type')"
              v-validate="'required'"
              @input="
                ordertoarrive.deliverySelectedSub = null
                $forceUpdate()
              "
            >
              <option v-for="optio in this.deliveryTypeDictionary" :key="optio.key" :value="optio.key">
                {{ $translate(optio.key) }}
              </option>
            </b-select>
          </b-field>
        </template>
        <template
          v-if="
            deliveryTypeDictionary &&
              deliveryTypeDictionary.length != 0 &&
              deliveryTypeDictionary.find(temp => temp.key === ordertoarrive.deliverySelected) != undefined
          "
        >
          <b-field
            :label="$translate('deliverySelectedSub') | capitalize"
            :type="{ 'is-danger': errors.has('deliverySelectedSub') }"
            :message="errors.first('deliverySelectedSub')"
            v-if="deliveryTypeDictionary.find(temp => temp.key === ordertoarrive.deliverySelected).variant"
            horizontal
          >
            <b-select
              name="deliverySelectedSub"
              v-model="ordertoarrive.deliverySelectedSub"
              :placeholder="$translate('placeholder_type')"
              v-validate="'required'"
            >
              <option
                v-for="variant in deliveryTypeDictionary.find(temp => temp.key === ordertoarrive.deliverySelected)
                  .variant"
                :key="variant.key"
                :value="variant.key"
              >
                {{ $translate(variant.key) }}
              </option>
            </b-select>
          </b-field>
        </template>
        <b-field :label="$translate('copy_claim') | capitalize" horizontal>
          <b-switch v-model="copyClaimbool"> </b-switch>
        </b-field>

        <b-field :label="$translate('copy_model') | capitalize" horizontal>
          <b-switch @input="copyModelCheck" v-model="copyModel"> </b-switch>
        </b-field>
      </div>
    </form>
    <b-loading :is-full-page="true" :active.sync="isSaveDisabled" :can-cancel="false"></b-loading>
  </section>
</template>

<script>
import orderTools from '@/helpers/mixins/orderTools'
import firebase from 'firebase'
import keyWordGenerator from '@/helpers/mixins/keyWordGenerator.js'
import utilities from '@/helpers/mixins/utilities'
import { modelFits, modelModular, modelTailored } from '@/helpers/mixins/modelTools'

export default {
  $_veeValidate: {
    validator: 'new',
  },
  name: 'CopyOrder',
  mixins: [orderTools, keyWordGenerator, utilities],
  props: ['orderIdToCopy'],
  data() {
    return {
      isSaveDisabled: false,
      copyAttachbool: false,
      copyClaimbool: false,
      copyModel: false,
      bdictionary: null,
      ddictionary: null,
      bdictionary_fits: null,
      ddictionary_fits: null,
      bdictionary_modular: null,
      ddictionary_modular: null,
      patient: {},
      order: {},
      ordertoarrive: {},
      duplicatedOrder: {},
    }
  },
  computed: {
    config() {
      return this.$moduleConfiguration[this.ordertoarrive.module]
    },
    orderTypeDictionary() {
      return this.config ? this[this.config.bdictionary] : []
    },
    deliveryTypeDictionary() {
      return this.config ? this[this.config.ddictionary] : []
    },
  },
  created() {
    this.$validator.extend('unique', async value => {
      var temparray = []
      await this.$db
        .collection('orders')
        .where('primaryCode', '==', value)
        .get()
        .then(snapshot => {
          snapshot.forEach(doc => {
            if (doc.id != this.id) {
              temparray.push(doc.data().primaryCode)
            }
          })
        })

      if (temparray.includes(value)) {
        return false
      }
      return true
    })
  },
  async mounted() {
    this.isSaveDisabled = true
    await this.$db
      .collection('orders')
      .doc(this.orderIdToCopy)
      .get()
      .then(doc => {
        this.order = doc.data()
        let actualClaim = []
        for (let claim in this.order.claims) {
          if (this.order.claims[claim].AdminClaim) {
            this.order.claims[claim].id = actualClaim.length
            actualClaim.push(this.order.claims[claim])
          }
        }

        this.order.claims = actualClaim

        const module = this.order.module ? this.order.module : 'tailored'

        this.ordertoarrive = doc.data()
        this.ordertoarrive.module = module
        this.ordertoarrive.shoeType = null
        this.ordertoarrive.deliverySelected = null
        this.ordertoarrive.orderType = 'firstOrder'
        if (module === 'tailored') {
          this.ordertoarrive.orderTypeMain = null
          this.ordertoarrive.materialprod = []
          this.ordertoarrive.materialacc = []
        }
        this.ordertoarrive.primaryCode = null
        this.ordertoarrive.attachment = {}
        this.ordertoarrive.attachmentflag = {}
        this.ordertoarrive.secondaryCode = null
        this.ordertoarrive.tec = null
        this.ordertoarrive.send_date = null
        this.ordertoarrive.id_mercury = null
      })

    await this.loadPatientStatfromOrder()
    this.isSaveDisabled = false
  },
  methods: {
    copyModelCheck() {
      if (this.copyModelCheck) {
        this.ordertoarrive.shoeType = this.order.shoeType
        this.copyClaimbool = true
      }
    },
    async validateBeforeSubmit() {
      const result = await this.$validator.validateAll()
      if (result) {
        this.notification('start_copy', 'is-success')
        await this.send()
        return
      }
      this.notification('failed_form', 'is-danger')
    },
    async send() {
      this.isSaveDisabled = true
      this.ordertoarrive.statusOrder = 'draft'
      let realprimaryCode = this.ordertoarrive.primaryCode
      this.ordertoarrive.creationDate = new Date().getTime()
      this.ordertoarrive.searchArray = this.generateKeyWord([
        this.ordertoarrive.patient.name,
        this.ordertoarrive.patient.surname,
        this.ordertoarrive.patient.name + ' ' + this.ordertoarrive.patient.surname,
        this.ordertoarrive.primaryCode,
        this.ordertoarrive.id_mercury,
        this.ordertoarrive.company.name,
        this.ordertoarrive.shop.name,
        this.ordertoarrive.tec,
      ])

      await this.$db
        .collection('orders')
        .add(this.ordertoarrive)
        .then(docRef => {
          this.ordertoarrive.id = docRef.id
        })

      this.ordertoarrive.primaryCode = realprimaryCode
      //console.log(this.ordertoarrive.id);
      this.ordertoarrive.statusOrder = 'compord'
      if (this.copyAttachbool) {
        this.$buefy.notification.open({
          duration: 3000,
          message: this.$translate('start_copy_attach'),
          queue: false,
        })

        await this.copyAttach()
      }
      if (!this.copyClaimbool) {
        this.ordertoarrive.claims = {}
      } else {
        this.$buefy.notification.open({
          duration: 3000,
          message: this.$translate('start_copy_claim'),
          queue: false,
        })
        await this.copyAttachClaims()
      }

      if (!this.copyModel) {
        let newModel = new modelTailored()
        switch (this.ordertoarrive.module) {
          case 'tailored':
            newModel = new modelTailored()
            break
          case 'fits':
            newModel = new modelFits()
            break
          case 'modular':
            newModel = new modelModular()
            break
          default:
            newModel = new modelTailored()
        }
        this.ordertoarrive.mod = newModel.returnObject()
        // this.ordertoarrive.mod = this.ordertoarrive.module === 'tailored' ? new modelTailored() : new modelFits()
        // this.ordertoarrive.mod = this.ordertoarrive.mod.returnObject()
        this.ordertoarrive.mod.catalogchoose = true
      } else {
        this.$buefy.notification.open({
          duration: 3000,
          message: this.$translate('copy_model'),
          queue: false,
        })
      }

      this.ordertoarrive.lastModificationDate = new Date().getTime()
      var batch = this.$db.batch()
      var lookuppatients = this.$db.collection('patients').doc(this.ordertoarrive.patientId)
      batch.update(lookuppatients, {
        orders: firebase.firestore.FieldValue.arrayUnion(this.ordertoarrive.id),
      })
      var lookupshops = this.$db.collection('shops').doc(this.ordertoarrive.shopId)
      batch.update(lookupshops, {
        orders: firebase.firestore.FieldValue.arrayUnion(this.ordertoarrive.id),
      })
      var lookupcomp = this.$db.collection('companies').doc(this.ordertoarrive.companyId)
      batch.update(lookupcomp, {
        orders: firebase.firestore.FieldValue.arrayUnion(this.ordertoarrive.id),
      })
      var orderupdate = this.$db.collection('orders').doc(this.ordertoarrive.id)
      batch.update(orderupdate, this.ordertoarrive)
      batch
        .commit()
        .then(() => {
          this.isSaveDisabled = false
          this.$buefy.notification.open({
            duration: 3000,
            message: this.$translate('success_form'),
            type: 'is-success',
            queue: false,
          })
          this.$router.push({
            name: 'editOrder',
            params: { orderId: this.ordertoarrive.id, view: true, module: this.ordertoarrive.module },
          })
        })
        .catch(() => {
          //console.log(err);
          this.isSaveDisabled = false

          this.$buefy.notification.open({
            duration: 3000,
            message: this.$translate('error_form_server'),
            type: 'is-danger',
          })
        })
      this.isSaveDisabled = false
    },
    async copyAttachClaims() {
      for (let index in this.order.claims) {
        if (this.order.claims[index].attachbool) {
          await this.moveFirebaseClaimFile(
            'order/attachment/' + this.orderIdToCopy + '/claim/' + index,
            'order/attachment/' + this.ordertoarrive.id + '/claim/' + index,
            index
          )
        }
        if (this.order.claims[index].attachboolanswer) {
          await this.moveFirebaseClaimFile(
            'order/attachment/' + this.orderIdToCopy + '/claimanswer/' + index,
            'order/attachment/' + this.ordertoarrive.id + '/claimanswer/' + index,
            index
          )
        }
      }
    },
    async copyAttach() {
      if (this.order.attachment && Object.keys(this.order.attachment).length > 0) {
        for (let index in this.order.attachment) {
          if (this.order.attachment[index] != null) {
            await this.moveFirebaseAttachFile(
              'order/attachment/' + this.orderIdToCopy + '/' + index,
              'order/attachment/' + this.ordertoarrive.id + '/' + index,
              index
            )
          }
        }
      }
    },
    async primaryCodeCreation() {
      this.isSaveDisabled = true
      let mercurio_id = '-'
      await this.$db
        .collection('companies')
        .doc(this.order.companyId)
        .get()
        .then(async com => {
          mercurio_id = com.data().mercurio_id
          if (com.data().orders) {
            this.patient.progressivenumber = com.data().orders.length + 1
          } else {
            this.patient.progressivenumber = 1
          }
        })

      let today = new Date()
      let day = String(today.getUTCDate()).padStart(2, '0')
      let month = String(today.getUTCMonth() + 1).padStart(2, '0')

      this.ordertoarrive.primaryCode =
        day +
        month +
        today.getUTCFullYear() +
        '-' +
        mercurio_id +
        '-' +
        ('0000' + this.patient.progressivenumber).substr(-4, 4)

      this.isSaveDisabled = false
      this.$forceUpdate()
    },
    async moveFirebaseClaimFileAnswer(currentPath, destinationPath, index) {
      const cloneDeep = require('clone-deep')
      let oldRef = this.$storage.ref().child(currentPath)
      let oldmetadata = {}
      await oldRef.getMetadata().then(metadata => {
        oldmetadata.contentType = metadata.contentType
      })
      //console.log(oldmetadata);

      await oldRef
        .getDownloadURL()
        .then(async url => {
          await fetch(url).then(async htmlReturn => {
            let previousChunk = new Uint8Array()
            let fileArray = new Uint8Array()
            const reader = htmlReturn.body.getReader()
            await reader
              .read()
              .then(function appendStreamChunk({ done, value }) {
                if (value) {
                  previousChunk = cloneDeep(fileArray)
                  fileArray = new Uint8Array(previousChunk.length + value.length)
                  fileArray.set(previousChunk)
                  fileArray.set(value, previousChunk.length)
                }
                if (done) {
                  return fileArray
                } else {
                  return reader.read().then(appendStreamChunk)
                }
              })
              .then(async file => {
                await this.$storage
                  .ref()
                  .child(destinationPath)
                  .put(file, oldmetadata)
                  .then(async snapshot => {
                    //console.log(oldmetadata);

                    await snapshot.ref.getDownloadURL().then(url => {
                      this.ordertoarrive.claims[index].attachanswer = url
                      this.ordertoarrive.claims[index].attachboolanswer = true
                    })
                  })
              })
              .catch(() => {})
          })
        })
        .catch(() => {})
    },

    async moveFirebaseClaimFile(currentPath, destinationPath, index) {
      const cloneDeep = require('clone-deep')
      let oldRef = this.$storage.ref().child(currentPath)
      let oldmetadata = {}
      await oldRef.getMetadata().then(metadata => {
        oldmetadata.contentType = metadata.contentType
      })
      //console.log(oldmetadata);

      await oldRef
        .getDownloadURL()
        .then(async url => {
          await fetch(url).then(async htmlReturn => {
            let previousChunk = new Uint8Array()
            let fileArray = new Uint8Array()
            const reader = htmlReturn.body.getReader()
            await reader
              .read()
              .then(function appendStreamChunk({ done, value }) {
                if (value) {
                  previousChunk = cloneDeep(fileArray)
                  fileArray = new Uint8Array(previousChunk.length + value.length)
                  fileArray.set(previousChunk)
                  fileArray.set(value, previousChunk.length)
                }
                if (done) {
                  return fileArray
                } else {
                  return reader.read().then(appendStreamChunk)
                }
              })
              .then(async file => {
                await this.$storage
                  .ref()
                  .child(destinationPath)
                  .put(file, oldmetadata)
                  .then(async snapshot => {
                    //console.log(oldmetadata);

                    await snapshot.ref.getDownloadURL().then(url => {
                      //console.log(index);
                      this.ordertoarrive.claims[index].attach = url
                      this.ordertoarrive.claims[index].attachbool = true
                    })
                  })
              })
              .catch(() => {})
          })
        })
        .catch(() => {})
    },
    async moveFirebaseAttachFile(currentPath, destinationPath, index) {
      const cloneDeep = require('clone-deep')
      let oldRef = this.$storage.ref().child(currentPath)
      let oldmetadata = {}
      await oldRef.getMetadata().then(metadata => {
        oldmetadata.contentType = metadata.contentType
      })
      //console.log(oldmetadata);

      await oldRef
        .getDownloadURL()
        .then(async url => {
          await fetch(url).then(async htmlReturn => {
            let previousChunk = new Uint8Array()
            let fileArray = new Uint8Array()
            const reader = htmlReturn.body.getReader()
            await reader
              .read()
              .then(function appendStreamChunk({ done, value }) {
                if (value) {
                  previousChunk = cloneDeep(fileArray)
                  fileArray = new Uint8Array(previousChunk.length + value.length)
                  fileArray.set(previousChunk)
                  fileArray.set(value, previousChunk.length)
                }
                if (done) {
                  return fileArray
                } else {
                  return reader.read().then(appendStreamChunk)
                }
              })
              .then(async file => {
                await this.$storage
                  .ref()
                  .child(destinationPath)
                  .put(file, oldmetadata)
                  .then(async snapshot => {
                    //console.log(oldmetadata);

                    await snapshot.ref.getDownloadURL().then(url => {
                      //console.log(index);
                      this.ordertoarrive.attachment[index] = url
                      this.ordertoarrive.attachmentflag[index] = 1
                    })
                  })
              })
              .catch(() => {})
          })
        })
        .catch(() => {})
    },
  },
}
</script>
